import { type LucideIcon, BookOpen } from "lucide-react";
import { type ReactNode } from "react";
import { cn } from "@/lib/cn";

type Props = {
  icon?: LucideIcon;
  title: string;
  body?: string;
  action?: ReactNode;
  className?: string;
};

export function EmptyState({ icon: Icon = BookOpen, title, body, action, className }: Props) {
  return (
    <div
      className={cn(
        "flex flex-col items-center justify-center text-center",
        "rounded-xl border border-dashed border-border bg-surface dark:bg-bg",
        "px-6 py-12",
        className,
      )}
    >
      <div className="grid h-12 w-12 place-items-center rounded-full bg-surface-2 text-text-muted mb-4">
        <Icon className="h-5 w-5" />
      </div>
      <h3 className="font-display text-lg font-semibold">{title}</h3>
      {body ? <p className="mt-1.5 text-sm text-text-muted max-w-md">{body}</p> : null}
      {action ? <div className="mt-5">{action}</div> : null}
    </div>
  );
}
